import { render, staticRenderFns } from "./sales_get_started_page.vue?vue&type=template&id=66d84232&"
import script from "./sales_get_started_page.vue?vue&type=script&lang=js&"
export * from "./sales_get_started_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports